import React from "react"
import PropTypes from "prop-types"

const Star = ({
  style = {},
  width = "16px",
  className = "star",
  viewBox = "0 0 16 15"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <polygon
      fillRule="evenodd"
      points="8 12 3.29771798 14.472136 4.19577393 9.23606798 0.39154787 5.52786405 5.64885899 4.76393202 8 0 10.351141 4.76393202 15.6084521 5.52786405 11.8042261 9.23606798 12.702282 14.472136"></polygon>
  </svg>
)

Star.propTypes = {
  style: PropTypes.object,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Star
